module.exports = __webpack_public_path__ + "static/img/lb1.5dcce8b2.png";